<i18n>
{
  "en": {
    "terminal": {
      "serialnumber": "Serial number",
      "hardware": "Part number",
      "location": "Location",
      "credit": "Credit history (last 5)",
      "license": "License history (last 5)"
    },
    "titles": {
      "system": "System",
      "footer": "Press Continue to create configuration"
    },
    "buttons":{
      "continue": "Continue",
      "quit": "Quit",
      "back": "Back",
      "download": {
        "license": "Download latest config file",
        "credit": "Download latest time/pulse file"
      }
    },
    "history": {
      "days": "added {amount} days",
      "credit": "added {amount} credits"
    }
  },
  "da": {
    "terminal": {
      "serialnumber": "Serienummer",
      "hardware": "Part nummer",
      "location": "Lokation",
      "credit": "Credit historik (sidste 5)",
      "license": "Licens historik (sidste 5)"
    },
    "titles": {
      "system": "System",
      "footer": "Tryk på Fortsæt for at oprette en konfiguration"
    },
    "buttons":{
      "continue": "Fortsæt",
      "quit": "Afslut",
      "back": "Tilbage",
      "download": {
        "license": "Download seneste konfigurationsfil",
        "credit": "Download seneste tids-/pulsfil"
      }
    },
    "history": {
      "days": "tilføjede {amount} dage",
      "credit": "tilføjede {amount} kredit"
    } 
  }
}
</i18n>

<template>

  <layout>
    <b-container>
      <b-row>
        <b-col lg="8" offset-lg="2"> 
          <system-details :system="system" type="config" :compact="false"/>

          <b-row>
            <div id="system-footer">
              <h6>{{ $t('titles.footer') }}</h6>
            </div>
          </b-row>


          <b-row align-h="between"><!-- System Buttoms -->
              <b-button type="button" class="min-width-button" variant="outline-secondary" :to="{ name: 'systems' }">{{$t('buttons.back')}}</b-button>
              <b-button type="button" class="min-width-button" variant="outline-secondary" :to="{ name: 'issue-system-config', params: { logosid: this.system.LogosID }}"   >{{$t('buttons.continue')}}</b-button>
          </b-row>

        </b-col>
      </b-row>
    </b-container>
  </layout>

</template>

<script>

import moment from 'moment'
import FileSaver from 'file-saver'

import Layout from './Layout'
import SystemDetails from './subcomponent/SystemDetails'

import elg from '../api/elg.gateway.js'

export default {
  components: {
    Layout,
    SystemDetails
  },

  data() {
    return {
      system: {},
      files: {
        license: undefined,
        credit: undefined
      },
      licenseHistory: []
    };
  },

  methods: {
    parseDate (date){
      return moment(date).format('YYYY-MM-DD')
    },
    downloadCreditFile(){
      elg()
      .get('/api/v1/files/' + this.files.credit.FileID)
      .then((response) => {
        FileSaver.saveAs(new Blob([response.data]), this.files.credit.Filename);
      });
    }
  },

  mounted() {
    elg()
    .get(`/api/v1/systems/${this.$route.params.logosid}`)
    .then( res => {
      this.system = res.data;
    });
  },

  computed: {
    logosid () {
      return this.$route.params.logosid
    }
  }
};
</script>

<style scoped>

.file-button{
  margin-left: 40px;
  margin-bottom: 15px;
  min-width: 175px;
}


</style>


// WEBPACK FOOTER //
// WebApp/components/SystemConfigOverview.vue